import { render, staticRenderFns } from "./AreasInfo.vue?vue&type=template&id=61bef1e4&scoped=true&"
import script from "./AreasInfo.vue?vue&type=script&lang=js&"
export * from "./AreasInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bef1e4",
  null
  
)

export default component.exports